import * as localStorage from "../lib/localStorage";
import { Action } from "./actionRepository";

export interface EventActionParam {
    data: any;
    event: string;
    category: string;
    action: string;
    label: string;
    value: string;
}

export class EventAction implements Action {
    params: EventActionParam;

    constructor(params: EventActionParam) {
        this.params = params;
    }

    isFunction(data: any) {
        return data && {}.toString.call(data) === "[object Function]";
    }

    execute() {
        let userId = localStorage.getItem("contactFilter", "contactId");
        if (!userId) return; //Skip if no contact
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "https://evt.ungapped.com/custom", true);
        //xhr.open('POST', 'https://evt.ungapped.com/custom', true);
        xhr.setRequestHeader("Content-type", "application/JSON");
        let customEvent = {
            contactId: userId,
            event: this.params.event,
            category: this.params.category,
            action: this.params.action,
            label: this.params.label,
            value: this.params.value,
            data: null as unknown,
        };
        var payload = this.isFunction(this.params.data) ? this.params.data() : this.params.data;

        customEvent.data = JSON.stringify(payload);

        xhr.onload = function () {
            console.log(this.responseText);
        };
        xhr.send(JSON.stringify(customEvent));
    }
}
